import { render } from "./AddSeller.vue?vue&type=template&id=de561e24&scoped=true"
import script from "./AddSeller.vue?vue&type=script&lang=js"
export * from "./AddSeller.vue?vue&type=script&lang=js"

import "./AddSeller.vue?vue&type=style&index=0&id=de561e24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de561e24"]])

export default __exports__